<template>
    <div v-loading="loading" element-loading-text="上传中，请稍候...">
        <div class="info_case">
            <el-form label-width="120px" :model="infoData" size="mini">
                <el-form-item label="案件类型">
                    <el-select style="width:100%;" v-model="infoData.type" placeholder="请选择">
                        <el-option v-for="(item, index) in typeLists" :key="index" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预约支队">
                    <el-input value="周口市公安局交通管理支队" disabled></el-input>
                </el-form-item>
                <el-form-item label="预约大队">
                    <el-select style="width:100%;" v-model="infoData.organizationId" placeholder="请选择" @change="selectDadui">
                        <el-option v-for="(item, index) in daduiLists" :key="index" :label="item.fullName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预约时段">
                    <el-select style="width:100%;" v-model="dataValue" placeholder="请选择" @change="selectDate">
                        <el-option v-for="(item, index) in dateLists" :key="index" :label="item.dateTypeStr" :value="item.dateTypeStr"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select style="width:100%;" v-model="timeValue" placeholder="请选择" @change="selectTime">
                        <el-option v-for="(item, index) in timeLists" :key="index" :label="item.dateDesc" :value="item.dateDesc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="上传证据">
                    <div class="upload_title">注意：上传三证（驾驶证、身份证、行驶证）、身份证国徽面、驾驶证正本反面（带有条形码的一面）需为白色背景</div>
                    <ul class="upload_case">
                        <li class="upload_item">
                            <div class="img-box" v-if="threeCard && threeCard.url">
                                <img :src="getImageUrl(threeCard.url)" />
                                <div class="img-mask">
                                    <i class="el-icon-delete" @click="deleteImg(threeCard.url, 5)"></i>
                                    <i class="el-icon-zoom-in" @click="previewImg(threeCard.url)"></i>
                                </div>
                            </div>
                            <div class="img-box btn_case" v-else>
                                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg($event, 5)" />
                                <i class="el-icon-plus" style="font-size:38px;"></i>
                            </div>
                            <div class="upload_text">三证</div>
                        </li>
                        <li class="upload_item">
                            <div class="img-box" v-if="backIdCard && backIdCard.url">
                                <img :src="getImageUrl(backIdCard.url)" />
                                <div class="img-mask">
                                    <i class="el-icon-delete" @click="deleteImg(backIdCard.url, 6)"></i>
                                    <i class="el-icon-zoom-in" @click="previewImg(backIdCard.url)"></i>
                                </div>
                            </div>
                            <div class="img-box btn_case" v-else>
                                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg($event, 6)" />
                                <i class="el-icon-plus" style="font-size:38px;"></i>
                            </div>
                            <div class="upload_text">身份证国徽面</div>
                        </li>
                        <li class="upload_item" v-if="infoData.type == 1">
                            <div class="img-box" v-if="driverFrontBackCard && driverFrontBackCard.url">
                                <img :src="getImageUrl(driverFrontBackCard.url)" />
                                <div class="img-mask">
                                    <i class="el-icon-delete" @click="deleteImg(driverFrontBackCard.url, 10)"></i>
                                    <i class="el-icon-zoom-in" @click="previewImg(driverFrontBackCard.url)"></i>
                                </div>
                            </div>
                            <div class="img-box btn_case" v-else>
                                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg($event, 10)" />
                                <i class="el-icon-plus" style="font-size:38px;"></i>
                            </div>
                            <div class="upload_text">驾驶证正本反面</div>
                        </li>
                        <li class="upload_item" v-if="infoData.type == 1">
                            <div class="img-box" v-if="halfBodyPhoto && halfBodyPhoto.url">
                                <img :src="getImageUrl(halfBodyPhoto.url)" />
                                <div class="img-mask">
                                    <i class="el-icon-delete" @click="deleteImg(halfBodyPhoto.url, 22)"></i>
                                    <i class="el-icon-zoom-in" @click="previewImg(halfBodyPhoto.url)"></i>
                                </div>
                            </div>
                            <div class="img-box btn_case" v-else>
                                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg($event, 22)" />
                                <i class="el-icon-plus" style="font-size:38px;"></i>
                            </div>
                            <div class="upload_text">半身照</div>
                        </li>
                        <li class="upload_item" v-if="infoData.type == 2">
                            <div class="img-box" v-if="driverBackBackCard && driverBackBackCard.url">
                                <img :src="getImageUrl(driverBackBackCard.url)" />
                                <div class="img-mask">
                                    <i class="el-icon-delete" @click="deleteImg(driverBackBackCard.url, 13)"></i>
                                    <i class="el-icon-zoom-in" @click="previewImg(driverBackBackCard.url)"></i>
                                </div>
                            </div>
                            <div class="img-box btn_case" v-else>
                                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg($event, 13)" />
                                <i class="el-icon-plus" style="font-size:38px;"></i>
                            </div>
                            <div class="upload_text">驾驶证正页背面</div>
                        </li>
                        <template v-if="other.length">
                            <li class="upload_item" v-for="(item, index) in other" :key="index">
                                <div class="img-box">
                                    <img v-if="item.url.indexOf('.mp4') != -1" src="../../../assets/images/pics/player.png" />
                                    <img v-else :src="getImageUrl(item.url)" />
                                    <div class="img-mask">
                                        <i class="el-icon-delete" @click="deleteImg(item.url, 4, index)"></i>
                                        <i class="el-icon-zoom-in" @click="previewImg(item.url)"></i>
                                    </div>
                                </div>
                                <div class="upload_text">其他</div>
                            </li>
                        </template>
                        <li class="upload_item">
                            <div class="img-box btn_case">
                                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg,.mp4,.MP4" @change="updateImg($event, 4)" />
                                <i class="el-icon-plus" style="font-size:38px;"></i>
                            </div>
                            <div class="upload_text">其他</div>
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item label="驾驶证注册时间">
                    <el-date-picker style="width:100%;" type="date" v-model="infoData.driverCardTime" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="行驶证注册时间">
                    <el-date-picker style="width: 100%;" type="date" v-model="infoData.vehicleCardTime" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="是否加急">
                    <el-switch v-model="infoData.expedited"></el-switch>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="infoData.reporterName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="infoData.reportPhone" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="车辆号码">
                    <el-input v-model="infoData.carPlate" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="驾驶证号">
                    <el-input v-model="infoData.driverLicence" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="btn_case" label-width="0">
                    <el-button type="primary" size="mini" @click="onSubmit">现在预约</el-button>
                    <el-button size="mini" plain @click="onClose()">关闭</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import config from "@/common/env.js";

    export default {
        props: [],
        data () {
            return {
                loading: false,
                organizationParentId: 41,
                infoData: {
                    location: "河南省周口市鹿邑县鸣鹿办事处紫气大道公安局东南150米",
                    lat: "33.862943",
                    lng: "115.463122",
                    organizationId: null,
                    type: 1,
                    appointmentTime: null,
                    timePeriod: null,
                    startTime: null,
                    endTime: null,
                    driverCardTime: null,
                    vehicleCardTime: null,
                    expedited: false,
                    reporterName: null,
                    reportPhone: null,
                    carPlate: null,
                    driverLicence: null,
                },
                typeLists: [
                    { label: "简易程序", id: 1 },
                    { label: "一般程序", id: 2 },
                ],
                daduiLists: [],
                dataValue: null,
                dateLists: [],
                timeValue: null,
                timeLists: [],
                threeCard: null,
                backIdCard: null,
                driverFrontBackCard: null,
                driverBackBackCard: null,
                halfBodyPhoto: null,
                other: [],

            }
        },
        computed: {
            
        },
        created () {
            this.getDaduiList();
        },
        mounted () {
            
        },
        methods: {
            //获取大队
            getDaduiList() {
				this.$axios.get(`/admin/organization/childrenList/parent-${this.organizationParentId}/pc`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.daduiLists = data;
					}
				})
			},
            selectDadui(e) {
                // console.log(e)
                this.dataValue = null;
                this.dateLists = [];
                this.timeValue = null;
                this.timeLists = [];
                this.infoData.appointmentTime = null;
                this.infoData.timePeriod = null;
                this.infoData.startTime = null;
                this.infoData.endTime = null;    
                this.getTimeLists(e);
            },
            //获取预约时段
            getTimeLists(e) {
                let params = { organizationId: e, dateStr: "" };
                this.$axios.post(`/admin/appointment/datarule/list`, params).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
                    if(code == 0) {
                        this.dateLists = data;
                    } else {
                        this.$message.error(msg);
                    }
                })
            },
            selectDate(e) {
                // console.log(e)
                let _this = this;
                this.timeValue = null;
                this.timeLists = [];
                this.dateLists.forEach(item => {
                    if(item.dateTypeStr == e) {
                        _this.timeLists = item.dataRule;
                        _this.infoData.appointmentTime = new Date(item.dateStr).getTime();
                        _this.infoData.timePeriod = item.dateType;
                    }
                })
            },
            selectTime(e) {
                // console.log(e)
                let _this = this;
                this.timeLists.forEach(item => {
                    if(item.dateDesc == e) {
                        _this.infoData.startTime = item.start;
                        _this.infoData.endTime = item.end;
                    }
                })
            },

            updateImg(e, fileType) {
                let file = e.target.files[0];

                let fromdata = new FormData();
                fromdata.append("file", file);
                fromdata.append("fileType", fileType);

                this.loading = true;
                    
                this.$axios.post(`/admin/appointment/upload/evidence`, fromdata).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
                    if(fileType != 5) this.loading = false;
                    if(code == 0) {
                        if(fileType == 5) {
                            this.threeCard = { url: data.url };
                            this.readOcr(data.url, fileType);
                        } else if(fileType == 6) {
                            this.backIdCard = { url: data.url };
                        } else if(fileType == 10) {
                            this.driverFrontBackCard = { url: data.url };
                        } else if(fileType == 13) {
                            this.driverBackBackCard = { url: data.url };
                        } else if(fileType == 22) {
                            this.halfBodyPhoto = { url: data.url };
                        } else if(fileType == 4) {
                            this.other = [...this.other, ...[{ url: data.url }]];
                        }
                    } else {
                        this.$message.error(msg);
                    }
                    this.resetFile(e);
                }).catch(err => {
                    this.loading = false;
                })
            },

            deleteImg(filePath, fileType, index) {
                let params = { filePath, fileType: null, recordId: null, }
				this.$axios.post(`/admin/appointment/remove/card`, params).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
                    if(code == 0) {
                        if(fileType == 5) {
                            this.threeCard = null;
                        } else if(fileType == 6) {
                            this.backIdCard = null;
                        } else if(fileType == 10) {
                            this.driverFrontBackCard = null;
                        } else if(fileType == 13) {
                            this.driverBackBackCard = null;
                        } else if(fileType == 22) {
                            this.halfBodyPhoto = null;
                        } else if(fileType == 4) {
                            this.other.splice(index, 1);
                        }
                    } else {
                        this.$message.error(msg);
                    }
                })
			},

            readOcr(filePath, fileType) {
                let params = { filePath, fileType, width: 360, height: 1110, isCut: false, }
                this.$axios.post(`/admin/appointment/ocr`, params).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
                    this.loading = false;
                    if(code == 0) {
                        if(fileType == 5) {
                            this.infoData.driverCardTime = data.driver && data.driver.dateOfFirstIssue ? new Date(data.driver.dateOfFirstIssue).getTime() : this.infoData.driverCardTime;
                            this.infoData.vehicleCardTime = data.vehicle && data.vehicle.registerDate ? new Date(data.vehicle.registerDate).getTime() : this.infoData.vehicleCardTime;
                            this.infoData.reporterName = this.infoData.reporterName ? this.infoData.reporterName : data.idCard ? data.idCard.name : null;
                            this.infoData.carPlate = data.vehicle ? data.vehicle.plateNo : null;
                            this.infoData.driverLicence = data.driver ? data.driver.driverCardNo : null;

                            this.threeCard = {...this.threeCard, ...{info: JSON.stringify(data)}};
                        }
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(err => {
                    this.loading = false;
                })
            },

            onSubmit() {
                let params = JSON.parse(JSON.stringify(this.infoData));
                let msg = "";
                console.log(params)
                
                if(params.type == 1) {
                    params = {...params, ...{
                        threeCard: this.threeCard,
                        backIdCard: this.backIdCard,
                        driverFrontBackCard: this.driverFrontBackCard,
                        halfBodyPhoto: this.halfBodyPhoto && this.halfBodyPhoto.url ? this.halfBodyPhoto.url : null,
                        other: this.other,
                    }}
                } else if(params.type == 2) {
                    params = {...params, ...{
                        threeCard: this.threeCard,
                        backIdCard: this.backIdCard,
                        driverBackBackCard: this.driverBackBackCard,
                        other: this.other,
                    }}
                }

                if(params.organizationId == null) {
                    msg = "请选择预约大队";
                } else if(params.appointmentTime == null || params.appointmentTime == "") {
                    msg = "请选择预约时段";
                } else if(params.startTime == null || params.startTime == "") {
                    msg = "请选择具体预约时段";
                } else if(params.driverCardTime == null || params.driverCardTime == "") {
                    msg = "请选择驾驶证注册时间";
                } else if(params.vehicleCardTime == null || params.vehicleCardTime == "") {
                    msg = "请选择行驶证注册时间";
                } else if(params.reporterName == null || params.reporterName == "") {
                    msg = "请输入姓名";
                } else if(params.reportPhone == null || params.reportPhone == "") {
                    msg = "请输入手机号";
                } else if(params.carPlate == null || params.carPlate == "") {
                    msg = "请输入车辆号码";
                } else if(params.driverLicence == null || params.driverLicence == "") {
                    msg = "请输入驾驶证号";
                }
                if(params.threeCard == null) {
                    msg = "请上传三证";
                } else if(params.backIdCard == null) {
                    msg = "请上传身份证国徽面";
                } else if(params.driverFrontBackCard == null && params.type == 1) {// 简单
                    msg = "请上传驾驶证正本反面";
                } else if(params.halfBodyPhoto == null && params.type == 1) {// 简单
                    msg = "请上传半身照";
                } else if(params.driverBackBackCard == null && params.type == 2) {// 一般
                    msg = "请上传驾驶证正页背面";
                }

                if(msg != "") {
                    return this.$message.error(msg);
                }

                this.$axios.post(`/admin/appointment/create`, params).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
                    if(code == 0) {
                        this.$message.success("创建预约单成功");
                        this.onClose({state: true});
                    } else {
                        this.$message.error(msg);
                    }
                })
            },

            previewImg(url) {
                let _this = this;
                if (this.$store.state.previewImgUrl) {
                    this.$store.commit("SHOW_PREVIEW_IMG", '')
                }
				setTimeout(() => {
                    localStorage.setItem("myPics", JSON.stringify([url]));
					_this.$store.commit("SHOW_PREVIEW_IMG", url);
				}, 500)
			},

            onClose(json) {
                this.$emit("hideCreate", json);
            },

            getImageUrl(url, type) {
                let str = type ? "/file/server/file" : "/file/server/decrypt/file";
				return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
			},

            resetFile (e) { //清空file
                e.target.type = "text";
                e.target.value = " ";
                e.target.type = "file";
                e.target.name = "file";
            },

        }
    }
</script>

<style scoped lang="scss">
    .info_case {
        width: 90%;
        margin: 0 auto;
    }
    .upload_title {
        width: 100%;
        line-height: normal;
        font-size: 12px;
        color: #e63517;
    }
    .upload_case {
        display: flex;
        flex-wrap: wrap;
    }
    .upload_item {
        width: 80px;
        // height: 80px;
        margin: 5px;

        .img-box {
            width: 80px!important;
            height: 80px!important;
            margin: 0 auto;
        }
    }
    .upload_text {
        width: 100%;
        line-height: normal;
        text-align: center;
        font-size: 11px;
    }
    .btn_case {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// create.vue?424915e6